import { render, staticRenderFns } from "./InvitedGroupsListModal.vue?vue&type=template&id=18ec3f7e&scoped=true&"
import script from "./InvitedGroupsListModal.vue?vue&type=script&lang=js&"
export * from "./InvitedGroupsListModal.vue?vue&type=script&lang=js&"
import style0 from "./InvitedGroupsListModal.vue?vue&type=style&index=0&id=18ec3f7e&lang=scss&scoped=true&"
import style1 from "./InvitedGroupsListModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ec3f7e",
  null
  
)

export default component.exports